import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {BaseFillDataFormComponent} from '../base-fill-data-form-component';
import {DictModel} from '../../../dictionary/dict.model';
import {EcvLanguageService} from '../../../core/ecv-language.service';

@Component({
  selector: 'app-label-dropdown',
  templateUrl: './label-dropdown.component.html'
})
export class LabelDropdownComponent extends BaseFillDataFormComponent {

  @Input() inputName: string;
  @Input() inputLabel: string;
  @Input() formGroup: FormGroup;
  @Input() items: DictModel[];

  constructor(private langService: EcvLanguageService) {
    super();
  }

  public getItemDescription(dict: DictModel): string {
    if (!dict) {
      return '';
    }

    return this.langService.pickFromDictionary(dict);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/form-section/label-dropdown/label-dropdown.component.ts